export function convertToJapaneseEra(year: number) {
  if (year >= 2019) {
    return year - 2018;
  }
  return null;
}
